import React from 'react';
import { Card, Title, Table, TableHead, TableRow, TableHeaderCell, TableBody, TableCell, Button, Badge } from '@tremor/react';

export function IntegrationsPage() {
  const integrations = [
    { 
      id: 1, 
      name: 'Shopify', 
      status: 'Connected', 
      lastSync: '2024-03-20 15:30:00' 
    },
    { 
      id: 2, 
      name: 'PayPal', 
      status: 'Connected', 
      lastSync: '2024-03-20 15:25:00' 
    },
    { 
      id: 3, 
      name: 'FedEx', 
      status: 'Error', 
      lastSync: '2024-03-19 10:15:00' 
    },
    { 
      id: 4, 
      name: 'eBay', 
      status: 'Not Configured', 
      lastSync: '-' 
    }
  ];

  const getStatusBadge = (status) => {
    const colors = {
      'Connected': 'green',
      'Error': 'red',
      'Not Configured': 'gray'
    };
    return <Badge color={colors[status]}>{status}</Badge>;
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <Title>Integrations</Title>
        <Button>+ Add Integration</Button>
      </div>

      <Card>
        <Table>
          <TableHead>
            <TableRow>
              <TableHeaderCell>Integration</TableHeaderCell>
              <TableHeaderCell>Status</TableHeaderCell>
              <TableHeaderCell>Last Sync</TableHeaderCell>
              <TableHeaderCell>Actions</TableHeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {integrations.map(integration => (
              <TableRow key={integration.id}>
                <TableCell>{integration.name}</TableCell>
                <TableCell>{getStatusBadge(integration.status)}</TableCell>
                <TableCell>{integration.lastSync}</TableCell>
                <TableCell>
                  <div className="space-x-2">
                    <Button size="xs" variant="secondary">Configure</Button>
                    <Button size="xs" variant="secondary">View Logs</Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
} 